<template>
  <div v-if="template === 'badge'" class="et-badge">
    <i class="fal fa-clock"></i>
    <span v-if="expiredTimer !== 'expired'">{{ textType }} expires in <strong>{{ expiredTimer }}</strong></span>
    <span v-else>{{ textType }} has expired</span>
    <button
      v-if="expiredTimer === 'expired' && allowApplyAnyway"
      class="et-apply-link"
      @click.stop="$emit('apply-anyway')"
    >
      Apply anyway
    </button>
  </div>
  <div v-else-if="template === 'list'" class="et-list">
    <div class="et-list-icon"><i class="fal fa-clock"></i></div>
    <div class="et-list-text">
      <span v-if="expiredTimer !== 'expired'">{{ textType }} expires in <strong>{{ expiredTimer }}</strong></span>
      <span v-else>{{ textType }} has expired</span>
      <button
        v-if="expiredTimer === 'expired' && allowApplyAnyway"
        class="et-apply-link et-apply-link--list"
        @click.stop="$emit('apply-anyway')"
      >
        Apply anyway
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpiredTimer",
  props: {
    template: {
      type: String,
      required: false,
      default: "badge"
    },
    campaignInfluencer: {
      type: Object,
      required: false,
      default: null
    },
    allowApplyAnyway: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    // data
  }),
  computed: {
    textType() {
      if (this.campaignInfluencer.invitation) {
        return "The invitation";
      } else {
        return "The application";
      }
    },
    expiredTimer() {
      const expired = this.$moment.utc(this.campaignInfluencer.expires_at);
      const now = this.$moment().utc();
      const daysLeft = expired.diff(now, "days");
      const hoursLeft = expired.diff(now, "hours");
      const minsLeft = expired.diff(now, "minutes");
      if (minsLeft < 1) {
        return "expired";
      } else if (hoursLeft < 1) {
        return minsLeft === 1 ? `${minsLeft} minute` : `${minsLeft} minutes`;
      } else if (daysLeft < 1) {
        return hoursLeft === 1 ? `${hoursLeft} hour` : `${hoursLeft} hours`;
      } else {
        return daysLeft === 1 ? `${daysLeft} day` : `${daysLeft} days`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.et-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  font-weight: 600;
  color: #e05540;
  background: #fff0ee;
  border: 1px solid #fbd5cf;
  border-radius: 20px;
  padding: 7px 14px;
  line-height: 1.35;
  white-space: normal;

  i { font-size: 12px; flex-shrink: 0; }
  strong { font-weight: 700; }
}

.et-list {
  display: flex;
  align-items: center;
  gap: 10px;
}

.et-list-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff0ee;
  color: #e05540;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}

.et-list-text {
  font-size: 13px;
  font-weight: 500;
  color: #e05540;
  line-height: 1.4;

  strong { font-weight: 700; }
}

.et-apply-link {
  margin-left: 10px;
  background: #fff;
  border: 1px solid #e05540;
  border-radius: 20px;
  padding: 4px 12px;
  font: inherit;
  font-size: 11.5px;
  font-weight: 700;
  color: #e05540;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.et-apply-link:hover { background: #e05540; color: #fff; }
.et-apply-link--list { display: inline-block; margin-left: 6px; margin-top: 2px; }
</style>